import { Type } from "class-transformer";
import { Permission } from "./Permission";

export default class RoleCreate {
    name: string = "";
    description: string = "";
    @Type(() => Permission)
    permissions: Permission[] = [];
}
